import { h } from 'preact';

export const ErrorIcon = () => (
	<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M6.85433 1.63819L1.17957 11.0114C0.941484 11.4193 0.940063 11.9216 1.17583 12.3308C1.41161 12.7401 1.84916 12.9948 2.32524 13H13.6748C14.1508 12.9948 14.5884 12.7401 14.8242 12.3308C15.0599 11.9216 15.0585 11.4193 14.8204 11.0114L9.14567 1.63819C8.90276 1.24197 8.46838 1 8 1C7.53162 1 7.09724 1.24197 6.85433 1.63819Z"
			stroke="#E12424"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path d="M8 5V8" stroke="#E12424" stroke-linecap="round" stroke-linejoin="round" />
		<circle cx="8" cy="10" r="1" fill="#E12424" />
	</svg>
);

